import { FC } from 'react';
import { hideLoadingModalReducer, setAlertResponse, setValuesAndOpenAlertModalReducer, showLoadingModalReducer } from '@/store';
import { useDispatch } from 'react-redux';
import { userServices } from '@/services';

type propsType = {
};
    
export const UserDeleteAccount: FC<propsType> = ({ }) => {
    const dispatch = useDispatch();

    const deleteAccount = async (): Promise<void> => {
        dispatch(showLoadingModalReducer());
        const response = await userServices.DeleteMyAccount();
        dispatch(hideLoadingModalReducer());
        dispatch(setAlertResponse({ response, execution: () => window.location.reload() }));
    }

    return (
        <button className={'btn btn-general-red fw-bold py-2 my-2'}
            onClick={() => {
                dispatch(setValuesAndOpenAlertModalReducer({
                    mode: 'confirm',
                    title: "ELIMINAR LA CUENTA",
                    message: "Esta opción ELIMINARÁ IRREVERSIBLEMENTE ESTA CUENTA. SE PERDERÁN TODOS LOS DATOS ASOCIADOS A ELLA Y NO PODRÁN SER RECUPERADOS.",
                    execution: deleteAccount
                }));
            }}
        >
            ELIMINAR MI CUENTA
        </button>
    );
}
